import { makeAutoObservable } from "mobx";
import dataRequest from "../http/DataRequest";

class DangerousEventsStore {
  events = [];
  revision = null;
  isLoading = false;
  errorMessage = null;
  selectedEventTypes = [];
  orderNumSearch = "";

  constructor() {
    makeAutoObservable(this);
  }

  setSelectedEventTypes(types) {
    this.selectedEventTypes = Array.isArray(types) ? types : [];
  }

  setOrderNumSearch(value) {
    this.orderNumSearch = String(value ?? "").trim();
  }

  get summary() {
    let totalSum = 0;
    for (const ev of this.events) {
      for (const a of ev.attributes || []) {
        if (a.name === "sum") {
          const n = Number(a.value);
          if (!Number.isNaN(n)) totalSum += n;
        }
      }
    }
    return { count: this.events.length, totalSum };
  }

  setEvents(events, revision) {
    this.events = events;
    this.revision = revision;
  }

  setLoading(v) {
    this.isLoading = v;
  }

  setError(msg) {
    this.errorMessage = msg;
  }

  async fetchEvents(serverRowId, from_time, to_time, extra = {}) {
    if (serverRowId === "" || serverRowId == null) return;
    this.setLoading(true);
    this.setError(null);
    try {
      const body = {
        id: serverRowId,
        from_time,
        to_time,
        ...extra,
      };
      if (this.selectedEventTypes.length > 0) {
        body.eventTypes = this.selectedEventTypes;
      }
      if (this.orderNumSearch) {
        body.orderNums = [this.orderNumSearch];
      }
      const data = await dataRequest.getIikoEventsFilter(body);
      this.setEvents(data.events || [], data.revision ?? null);
    } catch (e) {
      const msg =
        e?.response?.data?.message ||
        e?.message ||
        "Не удалось загрузить события";
      this.setError(msg);
      this.setEvents([], null);
    } finally {
      this.setLoading(false);
    }
  }
}

const dangerousEventsStore = new DangerousEventsStore();

export default dangerousEventsStore;
